<script setup>
const props=defineProps({document:Object}),emit=defineEmits(['changed']);
const pending=ref(false),failure=ref('');
const {menu,closeMenu,onMenuFocusout}=usePostMenu();
async function remove(){
 if(!props.document?.can_manage||pending.value)return;
 closeMenu();
 if(!window.confirm('Скрыть публикацию? Её можно восстановить по этой ссылке.'))return;
 pending.value=true;failure.value='';
 try{await $fetch('/api/community/save',{method:'POST',body:{kind:'post',id:props.document.id,version:props.document.version,action:'delete'}});emit('changed');}
 catch(e){failure.value=e.data?.message||'Не удалось удалить пост. Попробуйте ещё раз.';}
 finally{pending.value=false;}
}
</script>
<template><div v-if="document?.can_manage"><details ref="menu" class="uo-post-menu" @keydown.esc.stop.prevent="closeMenu" @focusout="onMenuFocusout"><summary class="uo-icon-btn" aria-label="Действия с публикацией">⋯</summary><div class="uo-post-menu-panel"><a :href="'/feed/'+document.id+'/edit'" @click="closeMenu">Редактировать</a><button :disabled="pending" @click="remove">{{pending?'Удаляем…':'Удалить пост'}}</button></div></details><p v-if="failure" class="uo-alert" role="alert">{{failure}}</p></div></template>
